import { takeEvery } from 'redux-saga/effects';

import * as profileActions from 'store/modules/profile/licence';
import { watchLicenceStatus } from './utils';

export default function* listenLoadLicence() {
  yield takeEvery(profileActions.loadLicence.toString(), watchLicenceStatus);
}
